import { IBasketOrderItem } from "../../../entities/manhattan/order/types";
import { IManhattanFactory } from "../types";
import ItemsTotal from "../../../entities/manhattan/basket/ItemsTotal";
import { getOrderItemsByType } from "../../../utilites/order";
import { deviceTypes } from "../../../constants/TelcoDeviceTypes";
import { OrderItemsTypes } from "../../../constants/OrderItemsTypes";

export const ItemsPriceFactory: IManhattanFactory = class ItemsPriceFactory {

  static create(basketItems: IBasketOrderItem[], orderType: string) {
    const deviceItems = getOrderItemsByType(basketItems, deviceTypes);
    const otherItemTypes = [OrderItemsTypes.COSMOS_PARTICIPATION, OrderItemsTypes.MSISDN, OrderItemsTypes.SIM_ACTIVATION, OrderItemsTypes.MIN_PARTICIPATION, OrderItemsTypes.SUBSCRIPTIONS_IN_ADVANCE, OrderItemsTypes.INSURANCE];
    const otherItems = getOrderItemsByType(basketItems, otherItemTypes);
    const tariffPackageItems = getOrderItemsByType(basketItems, [OrderItemsTypes.TARIFF_PACKAGE]);

    const calculateTotal = (array: IBasketOrderItem[] | undefined): number => {
      if (array) {
        return array.reduce((acc, item) => {
          if (item.checkoutPrice) {
            return acc + Number(item.checkoutPrice.amount);
          }
          return 0;
        }, 0);
      }
      return 0;
    };

    return new ItemsTotal(
      calculateTotal(deviceItems),
      calculateTotal(otherItems),
      calculateTotal(tariffPackageItems)
    );
  }

};
